"use client";

import { useContext } from "react";

import { abContext } from "../lib/abContext";

export const useABContext = () => useContext(abContext);
